export default {"src":"/_next/static/media/badge-fire.1d7d8075.svg","height":12,"width":10,"blurWidth":0,"blurHeight":0};